import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { IPost } from '../../types';

interface IProps {
	post: IPost;
}

const Default = ({ post }: IProps) => {
	const formatDate = (dateString: string) => {
		const date = new Date(dateString);
		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
		const year = String(date.getFullYear()).slice(-2);
		return `${month}.${day}.${year}`;
	};

	const formattedDate = formatDate(post.post_date);

	const cardClass = post.featured_image
		? 'pfa-card-default'
		: 'pfa-card-default pfa-card-default--no-image';

	return (
		<a href={post.permalink} target="_self" rel="noreferrer" className={cardClass}>
			<div className="pfa-card-default__content cms">
				<div className="pfa-card-default__tag-container">
					<p
						className="pfa-card-default__tag"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.category.name) }}
					></p>
					<p
						className="pfa-card-default__tag-date"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(formattedDate) }}
					></p>
				</div>
				<div className="pfa-card-default__title-container">
					{!!post.featured_image && (
						<figure
							className="pfa-card-default__figure"
							dangerouslySetInnerHTML={{ __html: post.featured_image }}
						></figure>
					)}
					<h3
						className="pfa-card-default__title"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_title) }}
					></h3>
				</div>
				<div className="pfa-card-default__link">
					<p
						className="pfa-card-default__date"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(formattedDate) }}
					></p>
					<p className="pfa-card-default__btn">
						<span className="icon-arrow-right"></span>
					</p>
				</div>
			</div>
		</a>
	);
};

Default.displayName = 'Default';

export default Default;
